import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../../components/layout/Header';
import { trackLogin } from '../../utils/analytics';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

const VisibilityIcon = MdVisibility as any;
const VisibilityOffIcon = MdVisibilityOff as any;

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    try {
      await login(email, password);
      trackLogin();
      navigate('/dashboard');
    } catch (error: any) {
      setError(error.message || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen flex-col bg-background">
      <div className="flex h-full grow flex-col">
        <Header variant="auth" />

        <div className="px-4 md:px-8 lg:px-40 flex flex-1 justify-center py-5">
          <div className="flex flex-col w-full max-w-md md:max-w-lg py-5 flex-1">
            <div className="flex flex-col items-center w-full">
              <h2 className="text-white tracking-light text-[28px] font-bold leading-tight px-4 text-center pb-3 pt-5">
              Welcome back
              </h2>
              {error && (
                <div className="mx-4 mb-4 p-3 bg-red-500/20 border border-red-500/30 rounded text-red-300 text-sm">
                  {error}
                </div>
              )}
              <form onSubmit={handleSubmit} className="flex flex-col items-center w-full">
              <div className="flex max-w-[480px] w-full flex-wrap items-end gap-4 px-4 py-3 justify-center">
                <label className="flex flex-col min-w-40 flex-1 max-w-[480px] w-full">
                <p className="text-white text-base font-medium leading-normal pb-2">Email</p>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded text-white focus:outline-0 focus:ring-0 border border-border-light bg-input-bg focus:border-border-light h-14 placeholder:text-text-secondary p-[15px] text-base font-normal leading-normal"
                />
                </label>
              </div>
              <div className="flex max-w-[480px] w-full flex-wrap items-end gap-4 px-4 py-3 justify-center">
                <label className="flex flex-col min-w-40 flex-1 max-w-[480px] w-full">
                <p className="text-white text-base font-medium leading-normal pb-2">Password</p>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded text-white focus:outline-0 focus:ring-0 border border-border-light bg-input-bg focus:border-border-light h-14 placeholder:text-text-secondary p-[15px] pr-12 text-base font-normal leading-normal"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-text-secondary hover:text-white transition-colors"
                  >
                    {showPassword ? (
                      <VisibilityIcon className="w-5 h-5" />
                    ) : (
                      <VisibilityOffIcon className="w-5 h-5" />
                    )}
                  </button>
                </div>
                </label>
              </div>
              <div className="flex max-w-[480px] w-full px-4 py-0 justify-end items-end">
                <Link
                  to="/forgot-password"
                  className="text-text-secondary text-sm font-normal leading-normal underline"
                >
                  Forgot password?
                </Link>
              </div>
                <div className="flex px-4 py-3 w-full justify-center">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="flex max-w-[450px] w-full cursor-pointer items-center justify-center overflow-hidden rounded h-12 px-5 bg-primary text-white text-base font-bold leading-normal tracking-[0.015em] disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span className="truncate">
                    {isLoading ? 'Logging in...' : 'Log in'}
                  </span>
                </button>
                </div>
              </form>
              <div className="text-center mt-6 px-4">
                <p className="text-text-secondary text-sm">
                  Don't have an account?{' '}
                  <Link
                    to="/signup"
                    className="text-primary hover:text-primary-hover font-medium underline"
                  >
                    Sign up
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
